import environment from '@/environment'
import request from '@/utils/request.js'
export const getToken = (parms) => {
  return request({
    url: `${environment.api_url}/survey/auth/token`,
    method: 'post',
    data: parms
  })
}
